import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { ADMIN_SECTION_SX } from "./adminStyles";

const AdminSection = ({ title, action, children }) => (
  <Paper component="section" aria-label={title} variant="outlined" sx={ADMIN_SECTION_SX}>
    {(title || action) && (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ mb: children ? 1.5 : 0 }}
      >
        {title ? (
          <Typography variant="subtitle1" fontWeight={800}>
            {title}
          </Typography>
        ) : (
          <Box />
        )}
        {action}
      </Stack>
    )}
    {children}
  </Paper>
);

export default AdminSection;
